import { ControllerBase, defineViewModel } from '@/utils/bizify';
interface PageData {
  email: string;
  emailVisible: boolean;
  code: string;
  count: number;
  walletAddress: string;
  isNameEdit: boolean;
  nickname: string;
  codeModalVisible: boolean;
  disablePasswordModalVisible: boolean;
  masterPasswordModalVisible: boolean;
  masterPassword: string;
}
class PageCtrl extends ControllerBase<PageData> {
  protected $data() {
    return {
      email: '',
      emailVisible: false,
      code: '',
      count: 0,
      walletAddress: '',
      isNameEdit: false,
      nickname: '',
      codeModalVisible: false,
      disablePasswordModalVisible: false,
      masterPasswordModalVisible: false,
      masterPassword: ''
    };
  }

  setEmail = (email: string) => {
    this.state.email = email;
  };

  setNameEdit = (isNameEdit: boolean) => {
    this.state.isNameEdit = isNameEdit;
  };

  setNickname = (nickname: string) => {
    this.state.nickname = nickname;
  };

  startCountDown = () => {
    this.state.count = 60;
    const timer = setInterval(() => {
      this.state.count--;
      if (this.state.count <= 0) {
        clearInterval(timer);
      }
    }, 1000);
  };

  setEmailVisible = (emailVisible: boolean) => {
    this.state.emailVisible = emailVisible;
  };

  setCode = (code: string) => {
    this.state.code = code;
  };

  setCodeModalVisible = (codeModalVisible: boolean) => {
    this.state.codeModalVisible = codeModalVisible;
  };

  toggleDisablePasswordModal = (visible: boolean) => {
    this.state.disablePasswordModalVisible = visible;
  };

  toggleMasterPasswordModal = (visible: boolean) => {
    this.state.masterPasswordModalVisible = visible;
  };

  setMasterPassword = (v: string) => {
    this.state.masterPassword = v;
  };
}

export const vm = defineViewModel(PageCtrl);
